import React, { useMemo } from 'react';
import { PageTitle } from 'ui/PageTitle';
import { SimpleTabs } from 'ui/SimpleTabs';
import { InvoiceUploadsTab } from './InvoiceUploadsTab';

export const InvoiceUploadsPage: React.FC = () => {
  const tabConfig = useMemo(
    () => [
      {
        title: 'Pending to Upload',
        name: 'pending',
        styles: 'flex-1',
        renderContent: () => (
          <InvoiceUploadsTab tab="pending" headerLabel="Invoices Pending to Upload" />
        ),
      },
      {
        title: 'Uploaded',
        name: 'uploaded',
        styles: 'flex-1',
        renderContent: () => (
          <InvoiceUploadsTab tab="uploaded" headerLabel="Uploaded Invoices" />
        ),
      },
    ],
    []
  );

  return (
    <div className="w-auto mx-[20px] crm-desktop:mx-[80px]">
      <div className="mb-4">
        <PageTitle primaryText="Invoices Uploads" />
      </div>
      <SimpleTabs tabConfig={tabConfig} forceEqualTabWidths className="pt-0 pb-0 w-full max-w-none mx-0" />
    </div>
  );
};
